'use client';
import Link from 'next/link';

import Button from '@/components/v2/Button';

const EventPage = () => {
  return (
    <div className="h-[calc(100vh-80px)] flex items-center justify-center w-full">
      <div>
        종료된 이벤트 페이지입니다.
        <br />
        <div className="justify-center flex mt-4 gap-4">
          <Button onClick={() => window.history.back()} size="xs" className="text-sm px-4">
            이전 페이지로 이동
          </Button>
          <Link href="/" className="mx-auto ">
            <Button size="xs" className="text-sm px-4">
              홈으로 돌아가기
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventPage;
